import { render } from "./NotificationViewComponent.vue?vue&type=template&id=2246b84c"
import script from "./NotificationViewComponent.vue?vue&type=script&lang=js"
export * from "./NotificationViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__